import { map as m,path,prop as p, compose as C,__,chain, last,
  reject,isNil,groupBy as g, indexBy,defaultTo,
} from "ramda"; 
import { weighted } from "./helpers";

const condition_inputs = C(
    reject(isNil),
    m(last),
    p("inputs")
  )

const conditional_show = email => x => {
  return [x.order_nr,
      x.condition === "yesNo" ? (Number(x.condition_input_data?.[0]?.value_number) === 1) :
      x.condition === "noYes" ? (Number(x.condition_input_data?.[0]?.value_number) === 0) :
      x.condition === "email" ? (x.condition_input_data?.[0]?.value_text === email) :
      x.condition === "veryPositive" ? (x.condition_avg >= 0.5) : 
      x.condition === "veryNegative" ? (x.condition_avg <= -0.5) : 
  false];
}

const condition_avgs = data => C(
  weighted,
  chain(p(__,g(p("activity_id"),data))),
  condition_inputs
)

const condition_input_data = data => C(
  chain(p(__,g(p("activity_id"),data))),
  condition_inputs
)

// Evaluated in process order. A condition is checked once every activity it
// depends on has been reached. A condition whose source activity was itself
// skipped can never be met, so it is skipped straight away: otherwise chained
// conditions (1 -> 2 -> 3) are only checked after the process has already
// moved onto the dependent step, which then hides itself and leaves no
// "next" button anywhere.
export const skip_list = (decision=[],data =[],session) => {
  const activities = C(
    chain(p("activities_with_types")),
    defaultTo([]),
    path([0,"decision_types","parts"])
  )(decision);
  const by_id = indexBy(p("id"),activities);
  const show_until = decision[0].show_until;
  const show = conditional_show(session.user.email);

  return [...activities].sort((a,b) => a.order_nr - b.order_nr).reduce((acc,x) => {
    const sources = condition_inputs(x).map(id => by_id[id]).filter(Boolean);
    if (!sources.length) return acc;
    if (sources.some(s => acc[s.order_nr] === false)) return {...acc,[x.order_nr]:false};
    if (Math.max(...sources.map(s => s.order_nr)) > show_until) return acc;
    const [order_nr,visible] = show({...x,
      condition_input_data:condition_input_data(data)(x),
      condition_avg:condition_avgs(data)(x)});
    return {...acc,[order_nr]:visible};
  },{});
}
